import AppleIcon from '@svg/social/appleIcon';
interface AppleLoginProps {
  action: any
}
const CustomFacebookLogin: React.FC<AppleLoginProps> = ({ action }) => {
  async function handleLogin() {
    action.onClick()
  }

  return (
    <button className=" w-12 h-12 flex justify-center items-center border rounded-lg" onClick={handleLogin} type="button" >
      <AppleIcon />
    </button>
  );
};

export default CustomFacebookLogin;
